// extracted by mini-css-extract-plugin
module.exports = {"cell":"Item_cell__347BX","icon":"Item_icon__16nrJ"};